export default __webpack_public_path__ + "static/media/1-5.80d2865e.png";